import React from 'react';
import { pdfjs } from 'react-pdf';
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from './pages/Index';
import './App.css';

// PDFワーカーの設定
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

function App() {
  return (
    <TooltipProvider>
      <div className="min-h-screen bg-gray-900">
        <Index />
        <Toaster />
      </div>
    </TooltipProvider>
  );
}

export default App;
